import { useSelector } from 'react-redux';
import { selectSessionAdvisor } from '../model/selectors';
import { Contacts } from '../components/integrations/Contacts';

export function AdvisorIntegrationsRedtailContacts() {
  const advisor = useSelector(selectSessionAdvisor);

  if (!advisor) {
    return <div>Loading...</div>;
  }

  return (
    <main className="px-4 pb-12 pt-3 sm:px-6 lg:px-8">
      {/* Header */}
      <div className="my-7 flex flex-col items-center justify-between gap-8 md:flex-row md:gap-0">
        <div className="flex items-center gap-5">
          <h1 className="text-primary-dark text-4xl font-semibold">Redtail Contacts</h1>
        </div>
      </div>
      {/* Divider */}
      <div className="bg-primary-100 my-6 h-px w-full" />

      <Contacts />
    </main>
  );
}
